import React from 'react';
import { BackupDashboard } from '@/components/backup/BackupDashboard';

const BackupPage: React.FC = () => {
  return <BackupDashboard />;
};

export default BackupPage;